import { RouteConfig } from 'vue-router';

export const NOT_FIND = {
  path: '*',
  name: 'notFind',
  component: () => import('../components/NotFind.vue'),
  meta: {
    index: 10,
  },
};

export const RouterTicketDetail = {
  path: '/TicketDetail',
  name: 'TicketDetail',
  // component: TicketDetail,
  component: () => import('../pages/mallDetail/index'),
};

export const RouterTicketPayResult = {
  path: '/TicketPayResult',
  name: 'TicketPayResult',
  component: () => import('../pages/payResult/TicketPayResult.vue'),
};

/**
 * 弹出框页面枚举配置，一般来说复杂的弹出框都可以单独拎出一个独立的页面处理，
 * 然后将其配置在这里，使用uiMgr.showPopPage(pageClass:any)来进行打开弹出框页面
*/
export const popEnums = {
  // POP_PART_INFO: { // 配件详情弹出框页面
  //   pageName: 'popPartInfo',
  //   pageClass: PartInfo,
  // },
};

/**
 * 路由枚举配置
*/
const routerEnums: RouteConfig[] = [
  // RouterTicketDetail,
  // RouterTicketPayResult,
];

export default routerEnums;
